import { useMemo } from 'react';
import {
	EngagementSpotlight,
	EngagementInlineDialog,
	Coordination,
	useCoordination,
} from '@atlassiansox/engagekit-ts';

import type { EngagementPlatformPluginConfig } from '@atlaskit/editor-plugin-engagement-platform';

import { useCoordinationClient } from '@confluence/engagement-provider';

export const useEditorEngagementPlatform = () => {
	const coordinationClient = useCoordinationClient();

	return useMemo(() => {
		const config: EngagementPlatformPluginConfig = {
			epComponents: {
				EngagementSpotlight,
				EngagementInlineDialog,
				Coordination,
			},
			epHooks: {
				useCoordination,
			},
			coordinationClient,
		};

		return {
			config,
		};
	}, [coordinationClient]);
};
